import { IResolutionEvent } from "../types/interfaces/IResolutionEvent";
import { useErrorContext } from "../../global/hooks/useErrorContext";

//This custom hook is responsible for making a POST request to the save resolution responses api endpoint.
export default function useSubmitResponse(apiSaveResolutionResponses: string): ((resolutionEventsToSubmit: IResolutionEvent[]) => Promise<IResolutionEvent[]>) {
    const { setError } = useErrorContext();

    const handleError = (message: string | null, statusCode: number) => {  
        setError({ message, statusCode });
        return [];
    };

    const submitResponse = async (resolutionEventsToSubmit: IResolutionEvent[]): Promise<IResolutionEvent[]> => {
        try {
            const response = await fetch(apiSaveResolutionResponses, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(resolutionEventsToSubmit)
            });
            if (!response.ok) {
                console.log('save', response.statusText);
                if (response.status === 401 || response.status === 403) {
                    return handleError(resolutionEventsToSubmit[0].ResolutionsStaticText.IneligibleText, -response.status);
                } else {
                    return handleError(null, -1);
                }
            }
            const result = await response.json();
            if (!result) {
                return handleError(null, -2);
            } else {
                if (result.Data === null || (!result.Succeeded && result.Errors !== null)) {
                    return handleError(null, -3);
                }

                if (result.Data && result.Data[0].Resolutions === null) {
                    return handleError(null, -4);
                }
            }
            return result.Data;
        } catch (error: any) {
            console.log('save error', error);
            return handleError(null, -error.status);
        }
    };

    return async (resolutionEventsToSubmit: IResolutionEvent[]) => {
        return submitResponse(resolutionEventsToSubmit);
    };
}